import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;800;900&family=Inter:wght@300;400;500;600;700;800&family=Cormorant+Garamond:wght@300;400;500;600;700&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #fafafa;
    color: #1a1a1a;
    line-height: 1.6;
  }

  /* Premium Typography Classes */
  .font-display {
    font-family: 'Playfair Display', serif;
    font-weight: 600;
    letter-spacing: -0.02em;
  }

  .font-display-bold {
    font-family: 'Playfair Display', serif;
    font-weight: 700;
    letter-spacing: -0.02em;
  }

  .font-display-black {
    font-family: 'Playfair Display', serif;
    font-weight: 800;
    letter-spacing: -0.02em;
  }

  .font-body {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    letter-spacing: 0.01em;
  }

  .font-body-medium {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    letter-spacing: 0.01em;
  }

  .font-body-semibold {
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    letter-spacing: 0.01em;
  }

  .font-body-bold {
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    letter-spacing: 0.01em;
  }

  .font-elegant {
    font-family: 'Cormorant Garamond', serif;
    font-weight: 400;
    letter-spacing: 0.02em;
  }

  .font-elegant-medium {
    font-family: 'Cormorant Garamond', serif;
    font-weight: 500;
    letter-spacing: 0.02em;
  }

  .font-elegant-semibold {
    font-family: 'Cormorant Garamond', serif;
    font-weight: 600;
    letter-spacing: 0.02em;
  }

  /* Enhanced Text Styles */
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Playfair Display', serif;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -0.02em;
  }

  h1 {
    font-weight: 700;
    font-size: 2.5rem;
  }

  h2 {
    font-weight: 600;
    font-size: 2rem;
  }

  h3 {
    font-weight: 600;
    font-size: 1.5rem;
  }

  p {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    line-height: 1.7;
    letter-spacing: 0.01em;
  }

  /* Premium Button Typography */
  button {
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    letter-spacing: 0.02em;
  }

  /* Form Elements */
  input, textarea, select {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    letter-spacing: 0.01em;
  }

  /* Navigation */
  nav {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    letter-spacing: 0.02em;
  }

  /* Code */
  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  /* Smooth Scrolling */
  html {
    scroll-behavior: smooth;
  }

  /* Focus Styles */
  *:focus {
    outline: 2px solid #1E2A78;
    outline-offset: 2px;
  }

  /* Selection */
  ::selection {
    background-color: #1E2A78;
    color: white;
  }

  /* Scrollbar Styling */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: #1E2A78;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #F7931E;
  }
`;

export default GlobalStyles; 